import { render, staticRenderFns } from "./BulkVerificationDetails.vue?vue&type=template&id=6aa3428b&scoped=true&"
import script from "./BulkVerificationDetails.vue?vue&type=script&lang=js&"
export * from "./BulkVerificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./BulkVerificationDetails.vue?vue&type=style&index=0&id=6aa3428b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3428b",
  null
  
)

export default component.exports